export default __webpack_public_path__ + "static/media/DK.225c3531.ico";